import { AccountingReportQueryController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows the accounting report builder for ad hoc reporting queries.
 * @example
 * ```html
 * <salaxy-accounting-report-query></salaxy-accounting-report-query>
 * ```
 */
export class AccountingReportQuery extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /**
       * Specify the calculations that should be reported.
       * If null, will show a user interface to select calculations or period.
       */
      calcs: "<",

      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<",
      /** The language for report*/
      lang: "<"
    };

    /** Uses the AccountingReportQueryController */
    public controller = AccountingReportQueryController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/AccountingReportQuery.html";

}
